/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { jwtDecode } from "jwt-decode";
import { isIFrame } from "@jda/lui-portal-utilities";
import {
  getAuthDetailsAction,
  showAuthDetailsError,
} from "../store/auth/authActionCreator";
import { getAuthPermissions } from "../store/auth/auth";
import { getPortalToken } from "../utility/commonUtility";
// import { mockResourcePermissions } from "../mockData/resourcePermissions";

const reqObj = [
  {
    namespace: "by.iam",
    resources: [
      {
        resource: "customer",
        data: [{ "*": "*" }],
      },
      {
        resource: "account",
        data: [{ "*": "*" }],
      },
      {
        resource: "application",
        data: [{ "*": "*" }],
      },
      {
        resource: "organization",
        data: [{ "*": "*" }],
      },
      {
        resource: "module",
        data: [{ "*": "*" }],
      },
      {
        resource: "api",
        data: [{ "*": "*" }],
      },
      {
        resource: "realm",
        data: [{ "*": "*" }],
      },
      {
        resource: "entitlement",
        data: [{ "*": "*" }],
      },
    ],
    checks: {
      entityPermissions: true,
      attributePermissions: false,
      dataPermissions: true,
    },
  },
];
export async function getAuthDetails(dispatch: Function) {
  let errorMessage: any = null;
  let assignedPermissions: any = [];
  let permissionsToken: any;
  let tokenDetails: any = { idp_preferred_username: "" };
  try {
    permissionsToken = await getPortalToken();
    tokenDetails = jwtDecode(
      isIFrame() ? permissionsToken.accessToken : permissionsToken
    );
    const payload = {
      subjectId: tokenDetails.sub,
      reqObj: reqObj,
    };
    assignedPermissions = await getAuthPermissions(dispatch, payload);
  } catch (error) {
    errorMessage = error;
  } finally {
    if (errorMessage !== null) {
      dispatch(showAuthDetailsError(errorMessage));
    } else {
      dispatch(getAuthDetailsAction(assignedPermissions));
    }
  }
}
